const LOW_PRIORITY_ANALYTICS_HOSTS = [
  'pendo.io',
  'datadoghq.eu',
  'aticdn.net',
  'ati-host.net',
];

// Datadog intake endpoints are hyphenated siblings, e.g. rum-browser-intake-datadoghq.eu
const LOW_PRIORITY_ANALYTICS_SUFFIXES = [
  ...LOW_PRIORITY_ANALYTICS_HOSTS.map((host) => `.${host}`),
  '-datadoghq.eu',
];

export const isLowPriorityAnalyticsUrl = (url: string): boolean => {
  try {
    const { hostname } = new URL(url);
    return (
      LOW_PRIORITY_ANALYTICS_HOSTS.includes(hostname) ||
      LOW_PRIORITY_ANALYTICS_SUFFIXES.some((suffix) =>
        hostname.endsWith(suffix),
      )
    );
  } catch {
    return false;
  }
};

let isInstalled = false;

// Chromium/Safari treat `priority: 'low'` as a hint; unsupported browsers ignore it.
// XHR and <img> pixel calls cannot be deprioritized this way.
export const installAnalyticsFetchPriority = (): void => {
  if (isInstalled || typeof window?.fetch !== 'function') {
    return;
  }

  const originalFetch = window.fetch.bind(window);

  window.fetch = ((input: RequestInfo | URL, init?: RequestInit) => {
    const url =
      typeof input === 'string'
        ? input
        : input instanceof URL
          ? input.href
          : input.url;

    if (isLowPriorityAnalyticsUrl(url)) {
      return originalFetch(input, { ...init, priority: 'low' });
    }

    return originalFetch(input, init);
  }) as typeof window.fetch;

  isInstalled = true;
};
